module.exports = __webpack_public_path__ + "static/media/alert.a1441af3.svg";